<template>
  <div class="cf-page">
    <!-- 顶部子导航 -->
    <div class="sub-nav">
      <a href="#/" class="sub-nav-back">← 返回首页</a>
      <span class="sub-nav-title">云论坛</span>
    </div>

    <!-- 头部文案 -->
    <section class="cf-head">
      <div class="cf-head-tag">
        <span class="cf-head-line"></span>
        CLOUD FORUM
        <span class="cf-head-line"></span>
      </div>
      <h1 class="cf-head-title">云论坛</h1>
      <p class="cf-head-desc">聚焦养老产业前沿议题，线上同步观看专家讲座与项目推介直播</p>
    </section>

    <!-- 论坛议程 -->
    <section class="cf-body">
      <div class="cf-list">
        <div
          v-for="(s, i) in sessions"
          :key="i"
          class="cf-card"
          :class="s.theme"
        >
          <div class="cf-side"></div>
          <div class="cf-content">
            <h3 class="cf-title">{{ s.title }}</h3>
            <div class="cf-intro-wrap">
              <span class="cf-intro-label">简介：</span>
              <span class="cf-intro-text">{{ s.intro }}</span>
            </div>
            <a href="#/" class="cf-btn">
              <span class="cf-play">▶</span>观看直播
            </a>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'CloudForum',
  data() {
    return {
      sessions: [
        {
          theme: 'orange',
          title: '养老产业项目及产品推介',
          intro: '汇聚省内外优质养老产业项目与前沿产品，邀请企业代表现场路演推介，涵盖智慧养老、适老化改造、康养旅居、辅助器具等多个领域，搭建项目对接与产品推广的高效平台。'
        },
        {
          theme: 'green',
          title: '中医保健讲座',
          intro: '邀请知名中医专家围绕老年养生、慢病调护、药膳食疗、经络保健等主题开讲，结合义诊与互动体验，传播中医康养理念，助力长者调理身心、乐享健康晚年。'
        }
      ]
    };
  }
};
</script>

<style scoped>
.cf-page {
  min-height: 100vh;
  background: #FFF4E6;
  padding-bottom: 120px;
}

/* ===== 顶部子导航 ===== */
.sub-nav {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18px 32px;
  background: #fff;
  border-bottom: 1px solid #F0E3D1;
}
.sub-nav-back {
  font-size: 15px;
  font-weight: 700;
  color: #E27A1D;
  text-decoration: none;
  letter-spacing: 0.5px;
}
.sub-nav-back:hover { opacity: 0.75; }
.sub-nav-title {
  font-family: var(--font-serif);
  font-size: 18px;
  font-weight: 900;
  color: var(--color-text);
}

/* ===== 头部 ===== */
.cf-head {
  text-align: center;
  padding: 100px 32px 64px;
}
.cf-head-tag {
  display: inline-flex;
  align-items: center;
  gap: 18px;
  color: #D4680A;
  font-family: var(--font-serif);
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 5px;
  margin-bottom: 20px;
}
.cf-head-line {
  display: inline-block;
  width: 36px;
  height: 1px;
  background: #E2A770;
}
.cf-head-title {
  font-family: var(--font-serif);
  font-size: clamp(44px, 7vw, 72px);
  font-weight: 900;
  color: #2B2420;
  margin: 0 0 18px;
  line-height: 1.1;
}
.cf-head-desc {
  font-size: 17px;
  line-height: 1.9;
  color: #6B5D54;
  margin: 0;
}

/* ===== 议程列表 ===== */
.cf-body { padding: 0 32px; }
.cf-list {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 28px;
}
.cf-card {
  position: relative;
  display: flex;
  background: #fff;
  border-radius: 20px;
  padding: 40px 48px 40px 0;
  box-shadow: 0 4px 20px rgba(237, 123, 26, 0.07);
  overflow: hidden;
}
.cf-side {
  flex-shrink: 0;
  width: 6px;
  margin-right: 36px;
  margin-left: 40px;
  border-radius: 4px;
  align-self: stretch;
  min-height: 160px;
}
.cf-card.orange .cf-side {
  background: linear-gradient(180deg, #F2A24A, #D15F16);
}
.cf-card.green .cf-side {
  background: linear-gradient(180deg, #3FB89E, #22876E);
}

.cf-content {
  flex: 1;
  min-width: 0;
}
.cf-title {
  margin: 0 0 18px;
  font-family: var(--font-serif);
  font-size: 28px;
  font-weight: 900;
  color: #2B2420;
  line-height: 1.3;
}
.cf-intro-wrap {
  margin-bottom: 28px;
  line-height: 1.95;
}
.cf-intro-label {
  font-size: 16px;
  font-weight: 800;
  color: #C25A2D;
}
.cf-intro-text {
  font-size: 16px;
  color: #5A4E46;
}

.cf-btn {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 14px 32px;
  color: #fff;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}
.cf-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(0,0,0,0.18);
}
.cf-card.orange .cf-btn {
  background: linear-gradient(135deg, #E2872E, #C25A2D);
  box-shadow: 0 8px 24px rgba(194, 90, 45, 0.35);
}
.cf-card.green .cf-btn {
  background: linear-gradient(135deg, #3FB89E, #22876E);
  box-shadow: 0 8px 24px rgba(34, 135, 110, 0.35);
}
.cf-play {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  padding-left: 2px;
}

@media (max-width: 820px) {
  .sub-nav { padding: 14px 20px; }
  .cf-head { padding: 64px 16px 48px; }
  .cf-body { padding: 0 16px; }
  .cf-card {
    padding: 28px 20px 28px 0;
    border-radius: 16px;
  }
  .cf-side {
    margin-left: 20px;
    margin-right: 20px;
  }
  .cf-title { font-size: 22px; }
}
</style>
